import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import BaseGynObsReport from "./BaseGynObsReport";

const AntenatalMonthlyAttendanceReport = ({ actions }) => (
  <BaseGynObsReport
    title="Antenatal Monthly Attendance Report"
    endpoint="obgyn/reports/antenatal-monthly-attendance"
    actions={actions}
    columns={[
      { key: "month", label: "Month" },
      { key: "total_contacts", label: "Total Contacts" },
      { key: "unique_mothers", label: "Unique Mothers" },
    ]}
  />
);

const mapDispatchToProps = (dispatch) => ({
  actions: {
    snackbarActions: bindActionCreators(snackbarActions, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(AntenatalMonthlyAttendanceReport);
